import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar} from 'shared/components';

const PositionChangeEntry = ({entry}) => {
  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={entry.user} size='sm' />
      <div className='flex-1'>
        <div className='flex items-center gap-2'>
          <div>
            <span className='h3 waterloo pr1 whitespace-pre-line'>
              <FormattedMessage id='recruiting.hiring_funnel.MOVED_FROM' />
            </span>
            <span className='h3 whitespace-pre-line'>
              <FormattedMessage
                id='recruiting.hiring_funnel.POSITION_TO_POSITION'
                values={{
                  oldPosition: entry.oldPositionName,
                  newPosition: entry.newPositionName
                }}
              />
            </span>
          </div>
          <div className='h5 jumbo'>{entry.date}</div>
        </div>
        <div className='h5 jumbo'>{entry.name}</div>
        <div className='pt2 whitespace-pre-line'>
          {entry.text}
        </div>
      </div>
    </div>
  );
};

export default observer(PositionChangeEntry);
